import * as React from 'react';
import {Query, Mutation} from 'react-apollo';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {MessageContainer} from 'shells/message/message-container';
import {MessageGroup} from 'shells/message-group/message-group';

import type {
    GetNotifyMessages as GetNotifyMessagesQuery,
    DismissNotifyMessage as DismissNotifyMessageMutation,
    DismissNotifyMessageVariables,
} from 'nutshell-graphql-types';

import DISMISS_NOTIFY_MESSAGE from './graphql/mutations/dismiss-notify-message.graphql';
import GET_NOTIFY_MESSAGES from './graphql/queries/get-notify-messages.graphql';

class NotifyMessagesQuery extends Query<GetNotifyMessagesQuery, Record<any, any>> {}

class DismissNotifyMessage extends Mutation<
    DismissNotifyMessageMutation,
    DismissNotifyMessageVariables
> {}

export function NotifyMessages() {
    return (
        <DismissNotifyMessage mutation={DISMISS_NOTIFY_MESSAGE}>
            {(notifyMessageDismiss) => (
                <NotifyMessagesQuery query={GET_NOTIFY_MESSAGES}>
                    {({data}) => {
                        if (data && data.loggedInUser && data.loggedInUser.notifies) {
                            return (
                                <MessageContainer>
                                    {data.loggedInUser.notifies.map((message) => {
                                        return (
                                            <FlashBanner
                                                key={message.id}
                                                leftAlignContent={true}
                                                type='error'
                                                onHidden={() => {
                                                    notifyMessageDismiss({
                                                        variables: {
                                                            input: {id: message.id},
                                                        },
                                                        optimisticResponse: {
                                                            __typename: 'Mutation',
                                                            notifyMessageDismiss: {
                                                                // @ts-expect-error
                                                                __typename: 'NotifyMessageDismiss',
                                                                loggedInUser: {
                                                                    // @ts-expect-error
                                                                    __typename: 'User',
                                                                    ...data.loggedInUser,
                                                                    notifies: data.loggedInUser
                                                                        ? data.loggedInUser.notifies.filter(
                                                                              (notifyMessage) => {
                                                                                  return (
                                                                                      notifyMessage.id !==
                                                                                      message.id
                                                                                  );
                                                                              }
                                                                          )
                                                                        : [],
                                                                },
                                                            },
                                                        },
                                                    });
                                                }}
                                                animate={true}
                                                hasBorder={true}
                                            >
                                                <MessageGroup
                                                    title={message.message}
                                                    text={message.errors[0]}
                                                />
                                            </FlashBanner>
                                        );
                                    })}
                                </MessageContainer>
                            );
                        }

                        return null;
                    }}
                </NotifyMessagesQuery>
            )}
        </DismissNotifyMessage>
    );
}
